import CryptoJS from 'crypto-js'

export function encryptAES (text) {
  if (!text) return
  const key = CryptoJS.enc.Base64.parse(process.env.VUE_APP_BASE64_KEY)
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

export function decryptAES (encryptedText) {
  if (!encryptedText) return
  const key = CryptoJS.enc.Base64.parse(process.env.VUE_APP_BASE64_KEY)
  const decrypted = CryptoJS.AES.decrypt(encryptedText.replace(/ /g, '+'), key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}
